import {camelCaseToTitleCaseWithSpecialChars} from './getCamelCaseToTitleCase'

export const mapDropdownOptions = (options, toBeFormatted = false) => {
  if (options === null || options === undefined) {
    return []
  }
  if (typeof options === 'string') {
    options = options.length > 0 ? options.split(', ') : []
  }
  return options.map((option) => {
    if (typeof option === 'object') {
      return option
    } else {
      return {
        id: option,
        name: toBeFormatted ? camelCaseToTitleCaseWithSpecialChars(option) : option
      }
    }
  })
}

export const mapDropdownValue = (value, options) => {
  return options?.find((option) => option.name === value)
}

export const checkAlreadyExists = (value) => {
  try {
    return JSON.parse(value).status_code === 409
  } catch {
    return false
  }
}

export function isJsonString(str) {
  try {
    return typeof JSON.parse(str) === 'object'
  } catch {
    return false
  }
}

export const formatGivingCapacity = (value) => {
  if (!value) return ''
  const hasPlus = value.includes('+')
  const formattedValue = Number(value.replace('+', '')).toLocaleString('en-US')
  return `$${formattedValue}${hasPlus ? '+' : ''}`
}

export const formatStateAbbreivation = (stateValue, stateAbbreviation) => {
  if (!stateValue.length) return stateAbbreviation

  const state = stateValue.find((state) => state.id === stateAbbreviation)
  return state ? state.name : stateAbbreviation
}
